module.exports = __webpack_public_path__ + "static/media/锦鲤卡@2x.02ae8438.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/锦鲤卡@2x.png
// module id = 1533
// module chunks = 0